module.exports = __webpack_public_path__ + "img/logo-m2g-long-dark.8b531d1a.png";